import React, { useEffect, useState, useMemo } from "react";
import Slider from "react-slick";
import "./OurCourses.css";
import axios from "axios";
import { IMAGE_URL, BASE_URL } from "../../config/config";
import { Link } from "react-router-dom";

const OurCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const settings = useMemo(
    () => ({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2200,
      arrows: true,
      pauseOnHover: true,
      lazyLoad: "ondemand",
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1 } },
      ],
    }),
    []
  );

  useEffect(() => {
    let isMounted = true;

    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/course`);
        const allCourses = res.data.data.flatMap((cat) =>
          cat.courses.map((course) => ({
            ...course,
            category_name: cat.category_name,
          }))
        );

        if (isMounted) {
          setCourses(allCourses.slice(0, 6));
        }
      } catch (error) {
        console.error("Failed to fetch courses", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchCourses();
    return () => {
      isMounted = false;
    };
  }, []);

  const courseItems = useMemo(
    () =>
      courses.map((course) => (
        <div
          className="courses-item position-relative"
          key={course.product_name}
        >
          <img
            className="img-fluid"
            loading="lazy"
            src={`${IMAGE_URL}/uploads/${course.image}`}
            alt={course.product_name}
          />

          <div className="courses-text">
            <h4 className="text-center text-white px-3">
              {course.product_name}
            </h4>

            <div className="border-top w-100 mt-3">
              <div className="d-flex justify-content-between p-4 text-white">
                <span>
                  <i className="fa fa-user mr-2"></i>By Admin
                </span>
                <span>
                  <i className="fa fa-star mr-2"></i>
                  {course.rating || 4.5}
                  <small> ({course.reviews || 250})</small>
                </span>
              </div>
            </div>

            <div className="w-100 bg-white text-center p-4">
              {/* ✅ FIXED LINK */}
              <Link
                className="btn btn-coursedetails"
                to={`/course/${course.product_name}`}
                state={{ course }}
              >
                Course Detail
              </Link>
            </div>
          </div>
        </div>
      )),
    [courses]
  );

  if (loading) {
    return <div className="text-center my-5">Loading courses...</div>;
  }

  return (
    <div className="container-fluid px-0 py-1">
      <div className="row mx-0 justify-content-center">
        <div className="col-lg-6 text-center mb-3">
          <h6 className="text-uppercase text-secondary position-relative section-title">
            Our Courses
          </h6>
          <h2 className="display-4 font-weight-bold">
            Checkout New Releases Of Our Courses
          </h2>
        </div>
      </div>

      <div className="px-4 px-md-5">
        <Slider {...settings}>{courseItems}</Slider>
      </div>
    </div>
  );
};

export default OurCourses;
